import React from 'react';
import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import dt, { useIsMobile } from '../../../../../shared/theme';
import {
  CrossButton,
  DropdownIcon,
  DropdownText,
  OptionsContainer,
  OptionsContainerText,
} from '../../../common/dropdown/styles';
import { Button, Clear } from '../common';
import {
  FilterName,
  InnerContainer,
  SDropdownContainer,
} from './common';
import Option from './option';
import Hint from './hint';
import filterPropTypes from './prop-types';
import useFundsStateStore from '../../../common/funds-state-hook';
import Filter from '../fund-type-filter-components/filter';

const SOptionsContainer = styled(OptionsContainer)`
  z-index: 210;
  padding-bottom: 90px;
  outline: none;
`;

const Separator = styled.div`
  height: 0px;
  border-bottom: 1px solid #EEF1F5;
  margin: 16px -20px;
`;

const SButton = styled(Button)`
  width: ${props => (dt(props).theme.isMobile ? '100%' : '105px')};
  margin-left: ${props => (dt(props).theme.isMobile ? 0 : 'auto')};
  height: 48px;
  font-size: 16px;
`;

const SFilterName = styled(FilterName)`
  margin-top: 32px;
`;

const SDropdownIcon = styled(DropdownIcon)`
  margin-right: 12px;
`;

const SOptionsContainerText = styled(OptionsContainerText)`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

const ActionContainer = styled.div`
  position: fixed;
  display: none;
  flex-direction: row;
  align-items: center;
  width: 100%;
  left: 0;
  bottom: 0;
  padding: 20px;
  background-color: ${props => dt(props).theme.bodyBackgroundColor};
  border-top: 1px solid #EEF1F5;
  z-index: 211;

  ${props => props.theme.isMobile && `
    flex-direction: column;
  `};

  &.show {
    display: flex;
  }
`;

export default function Mobile({
  assetClasses,
  clearFilter,
  dropdownLabel,
  dropdownClassName,
  filterCount,
  onClick,
  onClose,
  showOptions,
  applyFilter,
}) {
  const isMobile = useIsMobile();
  const showAssetClassFilterHint = useFundsStateStore(state => state.showAssetClassFilterHint);
  const ref = React.useRef();
  const clearButton = (
    <Clear className={filterCount > 0 ? 'active' : ''} onClick={clearFilter}>
      {filterCount > 1 ? 'Clear All' : 'Clear'}
    </Clear>
  );

  return (
    <>
      <SDropdownContainer ref={ref} onClick={onClick} className={dropdownClassName}>
        <SDropdownIcon className="icon-lw icon-lw-filters" />
        <DropdownText>{dropdownLabel}</DropdownText>
      </SDropdownContainer>
      {showAssetClassFilterHint && <Hint ref={ref} />}
      <Modal
        open={showOptions}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <SOptionsContainer className={showOptions && !showAssetClassFilterHint ? 'slide-up' : 'slide-down'}>
          <CrossButton onClick={onClose}>&#10005;</CrossButton>
          <SOptionsContainerText>
            Filters
            {isMobile && clearButton}
          </SOptionsContainerText>
          <Separator />
          <Filter />
          {assetClasses.length > 0 && (
            <>
              <Separator />
              <SFilterName>Filter by Asset Class</SFilterName>
              <InnerContainer>
                {assetClasses.map(ac => <Option key={ac.id} assetClass={ac} />)}
              </InnerContainer>
            </>
          )}
          <ActionContainer className={showOptions ? 'show' : ''}>
            {!isMobile && clearButton}
            <SButton onClick={applyFilter}>Apply</SButton>
          </ActionContainer>
        </SOptionsContainer>
      </Modal>
    </>
  );
}

Mobile.propTypes = filterPropTypes;
